import { createFileRoute } from '@tanstack/react-router';
import { DataPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/data')({
  component: DataPage,
});
